import { Controller } from "@hotwired/stimulus";
import "./component.scss"

export default class extends Controller {
  static targets = ["editButton", "editForm"];

  toggleEdit() {
    this.editFormTarget.hidden = !this.editFormTarget.hidden;
    if (this.hasEditButtonTarget) this.editButtonTarget.setAttribute("aria-expanded", (!this.editFormTarget.hidden).toString());
    if (!this.editFormTarget.hidden) {
      requestAnimationFrame(() => this.editFormTarget.querySelector("input, textarea, select")?.focus());
    }
  }
}
